import { Box, styled } from '@mui/material';

export const Main = styled(Box)(() => ({
  width: '100%',
  paddingTop: 20,
}));
